<script>
import axios from 'axios';

export default {
  name: 'TrainingWidget',
  data() {
    return {
      trainingData: [{
        name: 'eingeladen',
        data: [['Schulungen', 0]],
      },
      {
        name: 'abgeschlossen',
        data: [['Schulungen', 0]],
      }],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      axios.get('/training/trainee')
        .then((response) => {
          const employees = response.data
            .filter(it => !it.isDelete);
          const notInvitedCound = employees
            .map(it => (!it.isInvitedToTraining ? 1 : 0))
            .reduce((acc, v) => acc + v, 0);
          const invitationCount = employees
            .map(it => (it.isInvitedToTraining && !it.trainedDate ? 1 : 0))
            .reduce((acc, v) => acc + v, 0);
          const finishedTrainingCount = employees
            .map(it => (it.trainedDate ? 1 : 0))
            .reduce((acc, v) => acc + v, 0);

          this.trainingData = [
            {
              name: 'nicht eingeladen',
              data: [['Schulungen', notInvitedCound]],
            },
            {
              name: 'eingeladen',
              data: [['Schulungen', invitationCount]],
            },
            {
              name: 'abgeschlossen',
              data: [['Schulungen', finishedTrainingCount]],
            }];
        });
    },
    openTraining() {
      this.$router.push('/trainings');
    },
  },
};
</script>

<template>
  <div>
    <v-card>
      <v-card-title class="cursor-pointer" @click="openTraining">
        <v-icon large left>
          school
        </v-icon>
        <span class="title">Schulungen</span>
      </v-card-title>
      <column-chart
        :stacked="true"
        :colors="['#D32F2F','#FB8C00', '#26a73a']"
        :data="trainingData"
      />
    </v-card>
  </div>
</template>
